// src/pages/pedidos/TaxaEntregaBairroSearch.js
import React, { useMemo, useState } from 'react';

import { useTaxaEntregaBairro } from '../../contexts/pedidos/TaxaEntregaBairroContext';
import ModalContainer from '../../components/modalForm/ModalContainer';
import ModalHeader from '../../components/modalForm/ModalHeader';
import ModalBody from '../../components/modalForm/ModalBody';
import ModalFooter from '../../components/modalForm/ModalFooter';
import ModalTable from '../../components/modalForm/ModalTable';
import { formatCurrency } from '../../utils/numberUtils';
import LazyLoading from '../../components/modalForm/LazyLoading';
import { normalizeText } from '../../utils/stringUtils';
import './TaxaEntregaBairroSearch.css';
import ModalSearchBar from '../../components/modalForm/ModalSearchBar';
import { ModalActionButton } from '../../components/modalForm/ModalActions';
import ModalSelectButton from '../../components/modalForm/ModalSelectButton';

const TaxaEntregaBairroSearch = ({ show, onHide, onSelect }) => {
  const { taxasEntregaBairro } = useTaxaEntregaBairro();
  const [filtro, setFiltro] = useState('');
  const registros = useMemo(() => taxasEntregaBairro.filter((item) =>
    normalizeText(item.descricao).includes(normalizeText(filtro))
  ), [taxasEntregaBairro, filtro]);

  if (!show) return null;
  return (
    <ModalContainer show={show} largura="600px" contentClassName="taxa-entrega-bairro-search-modal" variant="busca" onHide={onHide}>
      <ModalHeader title="Buscar Taxa de Entrega por Bairro" onHide={onHide} />
      <ModalBody>
        <ModalSearchBar label="Buscar bairro" placeholder="Filtrar por bairro..." value={filtro} onChange={(e) => setFiltro(e.target.value)} autoFocus size="100%" />
        <LazyLoading items={registros} resetKey={filtro}>
          {({ containerRef, handleScroll, visibleItems }) => (
            <ModalTable containerRef={containerRef} onContainerScroll={handleScroll}>
              <colgroup>
                <col style={{ width: '48px' }} />
                <col />
                <col style={{ width: '90px' }} />
                <col className="taxa-entrega-bairro-search-selecionar" />
              </colgroup>
              <thead><tr><th>Id</th><th className="text-start">Bairro</th><th className="text-end">Valor</th><th  className="modal-select-column"/></tr></thead>
              <tbody>{visibleItems.map((item) => (
                <tr key={item.id} onDoubleClick={() => onSelect(item)}>
                  <td className="text-center">{item.id}</td><td title={item.descricao}>{item.descricao}</td>
                  <td className="text-end">{formatCurrency(item.valor)}</td>
                  <td className="text-center modal-select-column">
                    <ModalSelectButton type="button" className="btn btn-outline-secondary btn-sm taxa-entrega-bairro-search-botao-selecionar" onClick={() => onSelect(item)} aria-label={`Selecionar ${item.descricao}`} />
                  </td>
                </tr>
              ))}</tbody>
            </ModalTable>
          )}
        </LazyLoading>
      </ModalBody>
      <ModalFooter><ModalActionButton type="button" className="btn btn-secondary btn-sm" onClick={onHide} action="close">Fechar</ModalActionButton></ModalFooter>
    </ModalContainer>
  );
};

export default TaxaEntregaBairroSearch;
